export default {
    //存放的键值对就是所要管理的状态
    instance: null,
    memberInfo: {},
    permission_ids: [],
    sale_info: {},
    sale_permission_ids: [],
    is_company: false,//是否为客户
    is_sales: false,//是否为销售
    is_platform_technician: false,//是否为平台大F
    is_technician: false,//是否为小F
    is_login: false,//是否登录
    is_part_time_sale: false,//是否为小S
    company_id: "",
    recommendGoodsList: [],//客户推荐商品
    current_company_id: "",
    switchCompany: null,
    insertOrder: [],
    company_info: {},
    regionData:[]
}


// WEBPACK FOOTER //
// ./src/store/state.js